import React from 'react';
import Image from 'next/image';
import type { GenericItem } from '@/client/contentfulClient';
interface FamilyPlanSectionProps {
  familyPlansContent: GenericItem;
}
export default function FamilyPlanSection({
  familyPlansContent
}: FamilyPlanSectionProps) {
  return <div className='flex w-full items-center justify-center py-14' data-sentry-component="FamilyPlanSection" data-sentry-source-file="FamilyPlanSection.tsx">
      <div className='flex w-[88%] max-w-screen-lg flex-col items-center justify-center gap-6 md:flex-row md:justify-between md:gap-16'>
        <div className='order-2 w-full md:order-1 md:max-w-[500px]'>
          <Image alt={familyPlansContent.image?.title ?? ''} className='w-full rounded-2xl' height={488} src={familyPlansContent.image?.url ?? ''} width={384} data-sentry-element="Image" data-sentry-source-file="FamilyPlanSection.tsx" />
        </div>
        <div className='order-1 flex w-full flex-col items-center justify-start gap-6 md:order-2 md:min-w-[452px]'>
          <div className='flex w-full flex-col items-center justify-start gap-6 md:items-center md:justify-center'>
            <h1 className='w-full text-4xl font-semibold md:max-w-md md:pr-6 md:text-start md:text-6xl' id='style-override-h2'>
              {familyPlansContent.title}
            </h1>
            <div className='w-full text-base md:max-w-md md:text-start' id='style-override-body-md'>
              {familyPlansContent.subtitle ? <p>{familyPlansContent.subtitle}</p> : null}
              <p className='mt-6'>{familyPlansContent.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}